import classNames from 'classnames';
import React from 'react';

import css from './IconVegetable.module.css';

const IconVegetable = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
    >
      <path
        d="M53.728 19.713c-.561-1.138-1.573-2.014-2.855-2.336-.962-.242-2.214-.333-3.807-.131a4.269 4.269 0 0 0-2.003.775c-.371.262-.852.594-1.413.906a15.443 15.443 0 0 1-1.412-.906 4.273 4.273 0 0 0-1.994-.775c-1.603-.202-2.845-.111-3.816.13-1.283.323-2.304 1.209-2.865 2.357l3.49 5.237H51.19l2.538-5.257z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M43.65 42.73v.011c.4 1.289.862 2.497 1.393 3.544.25.524.53 1.017.81 1.46 1.363 2.074 3.056 3.192 5.09 2.588 7.673-2.266 8.104-20.4 8.054-26.028-.02-2.034-1.363-3.836-3.326-4.33-.631-.16-1.392-.252-2.284-.241-.47.01-.972.04-1.533.11a4.298 4.298 0 0 0-1.993.776c-.06.04-.12.08-.18.13-1.072.746-2.926 1.853-4.749 2.075-.44.06-.871.06-1.292 0-.42.06-.851.06-1.282 0-1.933-.242-3.897-1.46-4.929-2.205-.11-.081-.21-.151-.33-.202a4.152 4.152 0 0 0-1.663-.574c-.832-.1-1.563-.13-2.214-.09-.601.02-1.132.1-1.603.221-1.963.494-3.305 2.296-3.326 4.33-.05 5.628.381 23.762 8.054 26.028 1.994.584 3.657-.463 5-2.457.23-.352.46-.735.67-1.148.631-1.158 1.162-2.507 1.633-3.987v-.01z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M51.19 32.55c0 11.29-3.378 18.37-7.545 18.37S36.1 43.84 36.1 32.55s3.378-10.614 7.545-10.614 7.545-.678 7.545 10.613z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M43.645 21.929S42.438 8.168 46.278 8"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M25.717 31.845c.96-.381 2.015-.473 3.004-.179 5.413 1.61 9.134 5.174 9.134 10.574 0 7.595-7.36 13.76-16.427 13.76C12.348 56 5 49.835 5 42.24c0-5.4 3.721-8.964 9.133-10.573.99-.295 2.047-.202 3.008.18 1.117.443 2.626.717 4.287.717 1.655 0 3.168-.275 4.289-.72z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M21.05 30.275a1.32 1.32 0 0 1 .755 0c.64.188 1.562.317 1.998.314a4.504 4.504 0 0 0 2.293-.659c.634-.385 1.979-.894 3.73.145 2.47 1.465 3.28-.285 3.28-.285s-1.999 4.18-5.522 3.76c.543 2.665 4.792 4.234 4.792 4.234s-6.003-.936-8.672-2.932a.52.52 0 0 0-.838.437c.05 1.375-.164 3.533-1.438 6.118-1.274-2.585-1.488-4.743-1.438-6.118a.52.52 0 0 0-.839-.437c-2.668 1.996-8.671 2.932-8.671 2.932s4.249-1.569 4.792-4.234c-3.524.42-5.523-3.76-5.523-3.76s.81 1.75 3.28.285c1.752-1.04 3.096-.53 3.73-.145.69.419 1.487.653 2.293.659.436.003 1.359-.126 1.998-.314z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M21.428 30.22s.16-3.802 2.624-5.086l-2.624 5.086z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default IconVegetable;
